var toggleButtonGroupTexts = {
  'sv-SE': {
    all: 'Alla'
  },
  'nb-NO': {
    all: 'Alle'
  },
  'da-DK': {
    all: 'Alle'
  },
  'fi-FI': {
    all: 'Kaikki'
  }
};
var texts = toggleButtonGroupTexts;

export { texts as default };
//# sourceMappingURL=ToggleButtonGroup.texts.js.map
